/* eslint-disable no-bitwise */
import React from 'react';
import { PlusCircle } from 'react-feather';

const DropPlaceholder = () => (
  <div className="JourneyBuilderDropPlaceholder">
    <div className="JourneyBuilderDropPlaceholder-dropArea">
      <PlusCircle className="JourneyBuilderDropPlaceholder-icon" size={33} />
      <p className="JourneyBuilderDropPlaceholder-text">
        {t('journeys.builder.drop_msg')}
      </p>
    </div>
  </div>
);

export default DropPlaceholder;
